var _g, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.7143.857143c0-.473387.3837-.857143.8571-.857143 2.9981 0 5.4286 2.43045 5.4286 5.42857 0 .47339-.3838.85714-.8571.85714-.4734 0-.8572-.38375-.8572-.85714 0-2.05134-1.6629-3.71428-3.7143-3.71428-.4734 0-.8571-.38376-.8571-.857147z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.71429 14.5714c0-.4734-.38376-.8571-.857147-.8571s-.857143.3837-.857143.8571c0 2.9981 2.43045 5.4286 5.42857 5.4286.47339 0 .85714-.3838.85714-.8571 0-.4734-.38375-.8572-.85714-.8572-2.05134 0-3.71428-1.6629-3.71428-3.7143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5.42857c0-2.99812 2.43045-5.42857 5.42857-5.42857.47339 0 .85714.383756.85714.857143s-.38375.857147-.85714.857147c-2.05134 0-3.71428 1.66294-3.71428 3.71428 0 .47339-.38376.85714-.857147.85714s-.857143-.38375-.857143-.85714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 14.5714c0-.4734-.3838-.8571-.8571-.8571-.4734 0-.8572.3837-.8572.8571 0 2.0514-1.6629 3.7143-3.7143 3.7143-.4734 0-.8571.3838-.8571.8572 0 .4733.3837.8571.8571.8571 2.9981 0 5.4286-2.4305 5.4286-5.4286z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.5 2.5 5.5 4.5",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 2.5-5.5 4.5",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.5 17.5 5.5-4.5",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 17.5-5.5-4.5",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.a76b5d1520312b78d07d37204a10dd27.svg";
export { ForwardRef as ReactComponent };